import React from 'react';

import PropTypes from 'prop-types';
import {pure} from 'recompose';

import Loading from 'react-loading';

import {Text} from 'rebass';
import {Flex} from 'reflexbox';

import Avatar from './Avatar.js';
import Card from './Card.js';

let Message = (props) => {
  let avatar = (
    <Avatar
      for={props.author}
      size={40}
      key={'avatar'}
    />
  )

  let text = (
    <Card
      mx={1}
      key={'text'}
    >
      {props.pending ?
        <Loading type={'bubbles'} color='#00A8A2' height={32} width={32}/>:
        <Text> {props.text} </Text>
      }
    </Card>
  )

  return (
    <Flex
      align={'flex-start'}
      style={{
        marginBottom: 15,
        alignSelf: props.author === 'ai' ? 'flex-start': 'flex-end'
      }}
    >
      {props.author === 'ai' ?
        [avatar, text] :
        [text, avatar]
      }
    </Flex>
  )
}

Message.defaultProps = {
  pending: false,
  text: ""
}

Message.propTypes = {
  author: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired
};

export default pure(Message)



// WEBPACK FOOTER //
// ./src/components/Messsage.js